import type { AccessKey, AccessPermissions } from '@/types/permission';

export const permissions: Record<AccessKey, AccessPermissions> = {
  Admin: {
    today: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    planner: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    bookings: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    dashboard: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'opening-hour-and-dates': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    availability: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'closing-dates': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'discount-categories': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'smart-pricing': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    coupons: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'gift-cards': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    resources: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    activities: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'smart-suggestion': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'add-ons': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'food-and-beverage': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    payment: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    employeeManagement: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    roleManagement: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    locationManagement: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    settings: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    general: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    contactDetail: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    companyDetail: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    taxSetting: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    resellerSetting: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    groupTypeSetting: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    ageGroupPreset: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    groupSizePreset: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    giftCardValueSetting: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    integration: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    account: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    promoBanner: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    googleCalendar: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
  },
  'Company Admin': {
    today: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    planner: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    bookings: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    dashboard: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'opening-hour-and-dates': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    availability: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'closing-dates': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'discount-categories': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'smart-pricing': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    coupons: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'gift-cards': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    resources: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    activities: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'smart-suggestion': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'add-ons': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'food-and-beverage': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    payment: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    employeeManagement: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    roleManagement: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    locationManagement: {
      canView: false,
      canCreate: true,
      canEdit: false,
      canDelete: false,
    },
    settings: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    general: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    contactDetail: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    companyDetail: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    taxSetting: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    resellerSetting: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    groupTypeSetting: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    ageGroupPreset: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    groupSizePreset: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    giftCardValueSetting: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    integration: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    account: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    promoBanner: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    googleCalendar: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
  },
  Manager: {
    today: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    planner: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    bookings: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    dashboard: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'opening-hour-and-dates': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    availability: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'closing-dates': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'discount-categories': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'smart-pricing': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    coupons: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'gift-cards': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    resources: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    activities: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'smart-suggestion': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'add-ons': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    'food-and-beverage': {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    payment: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    employeeManagement: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    roleManagement: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    locationManagement: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    settings: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    general: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    contactDetail: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    companyDetail: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    taxSetting: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    resellerSetting: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    groupTypeSetting: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    ageGroupPreset: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    groupSizePreset: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    giftCardValueSetting: {
      canView: true,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    integration: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    account: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    promoBanner: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    googleCalendar: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
  },
  Employee: {
    today: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    planner: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    bookings: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    dashboard: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    'opening-hour-and-dates': {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    availability: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    'closing-dates': {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    'discount-categories': {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    'smart-pricing': {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    coupons: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    'gift-cards': {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    resources: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    activities: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    'smart-suggestion': {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    'add-ons': {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    'food-and-beverage': {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    payment: {
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
    },
    employeeManagement: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    roleManagement: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    locationManagement: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    settings: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    general: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    contactDetail: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    companyDetail: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    taxSetting: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    resellerSetting: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    groupTypeSetting: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    ageGroupPreset: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    groupSizePreset: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    giftCardValueSetting: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    integration: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    account: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    promoBanner: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
    googleCalendar: {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    },
  },
};
